import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Dimmer, Loader, Segment } from 'semantic-ui-react'
import { PulseLoader } from 'react-spinners'
import 'semantic-ui-css/components/dimmer.min.css'
import 'semantic-ui-css/components/loader.min.css'
import 'semantic-ui-css/components/segment.min.css'
import qs from 'qs'
import Helmet from 'react-helmet'

import Ad from '../components/Ad'
import FORMATS from '../components/AdFormats'
import { MobileElse, DesktopTablet, Mobile } from 'ion-media'
import { searchArticles, searchArticlesMore } from '../../store/search'
import Sidebar from '../components/Sidebar'
import ArticleCard from '../components/ArticleCard'
import IonArticle from 'ion-article'
import noImage from '../static/no-image.png'
import NoResults from '../static/icons/no-search-results-v2.svg'
import MagazineCover from '../components/MagazineCover'

export class SearchPage extends Component {
  constructor () {
    super()
    this.state = {
      isHidden: false,
      hasMounted: false
    }
    this.page = 0
    this.index = 0
    this.pageSize = 16
    this.handleViewMore = this.handleViewMore.bind(this)
  }

  componentDidUpdate (prevProps) {
    // Re-fetch articles when the section changes
    if (prevProps.query !== this.props.query) {
      this.props.searchArticles(this.props.query, this.index, this.pageSize)
    }
  }

  UNSAFE_componentWillMount () {
    // Fetch the first time this component is mounted
    const data = this.props.articles
    const lastFetch = new Date(this.props.lastFetch || 0)
    const now = new Date()
    this.params = !this.props.query ? qs.parse(this.props.location.search, { ignoreQueryPrefix: true }) : { q: this.props.query }
    this.page = this.params.page || 1
    if (!data || now - lastFetch > 1000) {
      this.props.searchArticles(this.params.q, this.index, this.pageSize)
    }
  }

  componentDidMount () {
    // Display the server-side view more button
    this.setState({
      isHidden: !this.state.isHidden,
      hasMounted: true
    })
  }

  handleViewMore () {
    const initialArticles = Math.max(this.index, 0)
    const alreadyFetchedArticles = (Math.max(this.page, 0) * this.pageSize)
    this.props.searchArticlesMore(this.params.q, initialArticles + alreadyFetchedArticles, this.pageSize)
    this.page++
  }

  render () {
    if (this.props.isEmpty || this.props.hasError) {
      return (
        <div className='wrapper no-results'>
          <Ad path={`/${process.env.RAZZLE_DFP_CODE}/search`} slotId='leaderboard-1' targeting={{ leaderboard: '1' }} className='advert-leaderboard-1' {...FORMATS.leaderboard} />
          <img src={NoResults} alt='No search results' />
          <h1>Nothing to see here</h1>
          <div>
            <p>Your search for <strong>{this.props.query}</strong> returned no results.</p>
          </div>
          <div className='no-results-search'>
            <form action='/search' method='get'>
              <input type='search' placeholder='Search Glamour' name='q' id='q' />
              <button>Search</button>
            </form>
          </div>
          {this.state.hasMounted &&
            <MobileElse>
              <Ad path={`/${process.env.RAZZLE_DFP_CODE}/search`} slotId='leaderboard-3' targeting={{ leaderboard: '3' }} className='advert-leaderboard-3' {...FORMATS.leaderboard} />
            </MobileElse>}
        </div>
      )
    }
    if (this.props.articles && this.props.articles.length && this.props.hasFetched) {
      const articles = this.props.articles.map(article => new IonArticle(article))
      return (
        <>
          <Ad path={`/${process.env.RAZZLE_DFP_CODE}/search`} slotId='leaderboard-1' targeting={{ leaderboard: '1' }} className='advert-leaderboard-1' {...FORMATS.leaderboard} />
          <h1>Search Results for <em>{this.props.query}</em></h1>
          <div className='wrapper article-listing'>
            <div className='article-list paged' itemType='http://schema.org/ItemList'>
              {articles.map((article, index) => {
                return (
                  <Fragment key={article.contentKey}>
                    <ArticleCard article={article} noImage={noImage} />
                    {(index === 2) && (
                      <Mobile>
                        <MagazineCover />
                      </Mobile>
                    )}
                  </Fragment>
                )
              })}
              {this.props.hasMore && (
                <div id='buttonContainer' className='more-from-btn noScript'>
                  <>
                    <PulseLoader color='#B10015' loading={this.props.isLoadingMore} margin='10px' />
                    <button id='viewMoreButton' onClick={this.handleViewMore}> View More</button>
                  </>
                  <Helmet>
                    <link rel='canonical' itemprop='url' href={process.env.RAZZLE_SITE_URL + this.props.location.pathname + '?query=' + this.props.query} />
                  </Helmet>
                </div>
              )}
              {this.props.children}
            </div>
            {this.state.hasMounted
              ? (
                <Sidebar {...this.props}>
                  <DesktopTablet>
                    <MagazineCover />
                  </DesktopTablet>
                </Sidebar>
                )
              : (
                <Sidebar {...this.props} />
                )}
          </div>
          {this.state.hasMounted &&
            <MobileElse>
              <Ad path={`/${process.env.RAZZLE_DFP_CODE}/search`} slotId='leaderboard-3' targeting={{ leaderboard: '3' }} className='advert-leaderboard-3' {...FORMATS.leaderboard} />
            </MobileElse>}
        </>
      )
    } else {
      return (
        <Segment>
          <Dimmer active>
            <Loader indeterminate size='large'>Loading...</Loader>
          </Dimmer>
        </Segment>
      )
    }
  }
}

SearchPage.propTypes = {
  searchArticles: PropTypes.func.isRequired,
  query: PropTypes.string
}

SearchPage.defaultProps = {
  articles: {}
}

const mapStateToProps = (state) => (state.search)
const mapDispatchToProps = (dispatch) => bindActionCreators({ searchArticles, searchArticlesMore }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage)
